// extracted by mini-css-extract-plugin
export default {"scrollableList":"Sidebar_scrollableList__HaIsM","theme-violet":"Sidebar_theme-violet__0wCLb"};